"use client";

import { Dialog, DialogContent } from "@/components/ui/dialog";
import Link from "next/link";
import LoginForm from "./LoginForm";
import useLoginStore from "@/src/store/useLoginStore";

const LoginView = () => {
    const { isLoginOpen, closeLogin } = useLoginStore();

    return (
        <Dialog open={isLoginOpen} onOpenChange={closeLogin}>
            <DialogContent aria-expanded={isLoginOpen}>
                <div className="flex justify-center items-center mb-4">
                    <h2 className="text-xl text-center font-semibold">ورود یا ثبت نام</h2>
                </div>
                <div>
                    <LoginForm onClose={closeLogin} />
                    <br />
                    <Link href="/rules" className="text-xs text-text" onClick={closeLogin}>
                        ورد شما به معنای پذیرش شرایط و قوانین هیرونیا میباشد
                    </Link>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default LoginView;
